﻿import {useGeocoder} from "./useGeocoder";
import {useEffect, useState} from "react";
import GeocoderResult = google.maps.GeocoderResult;
import {getQueryParamsFromPlace} from "../../util/AddressUtils";

export const useGeocodeByLatLng = ({latitude, longitude}: {latitude: any, longitude: any}) => {
    const {loading: geocoderLoading, geocoder} = useGeocoder();
    // Kept with the coordinates they answer, so new coordinates never return the
    // previous place or error while they load (securspace-ui#3053).
    const [geocoded, setGeocoded] = useState<{latitude: any, longitude: any, place: GeocoderResult}>();
    const [failure, setFailure] = useState<{latitude: any, longitude: any, error: any}>();

    useEffect(() => {
        let isCancelled = false;
        if (!geocoderLoading && geocoder?.geocode && latitude != null && longitude != null) {
            geocoder.geocode({ location: new google.maps.LatLng(latitude, longitude) }).then(({ results: places }: google.maps.GeocoderResponse) => {
                if (isCancelled) return;
                if (places?.length) {
                    const topPlace = places[0];
                    const addressParts = getQueryParamsFromPlace(topPlace);
                    if (addressParts?.city && addressParts?.state) {
                        setGeocoded({latitude, longitude, place: topPlace});
                        setFailure(undefined);
                    } else {
                        setFailure({latitude, longitude, error: new Error('Geocoding Result has no city or state')});
                    }
                } else {
                    setFailure({latitude, longitude, error: new Error('Failed to load place')});
                }
            }).catch((error: any) => {
                if (isCancelled) return;
                console.error(error);
                setFailure({latitude, longitude, error});
            })
        }
        return () => { isCancelled = true; };
    }, [geocoder, geocoderLoading, latitude, longitude]);

    return {
        geocodedPlace: geocoded && geocoded.latitude === latitude && geocoded.longitude === longitude ? geocoded.place : undefined,
        geocodingError: failure && failure.latitude === latitude && failure.longitude === longitude ? failure.error : undefined
    }
}
